import { useToast, Box, Card, CardBody, Flex, Image, Text, Icon, Center, Button, AlertDialog, AlertDialogOverlay, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, AlertDialogContent, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import api from "./servicos/Api";
import bg from './assets/login-bg.jpg';
import { IoChatboxOutline, IoCheckmarkOutline, IoPeopleOutline, IoReloadOutline } from "react-icons/io5";
import { versao } from "./servicos/Versao";

const Homemulti = () => {

    const appVersao = versao;

    const toast = useToast();

    const [noticias, setNoticias] = useState([]);
    const [dadosReuniao, setDadosReuniao] = useState(null);
    const [alertMsg, setAlertMsg] = useState({title: 'Info', texto: '', callback: null});
    const [aguarde, setAguarde] = useState({
        presenca: false,
        votacao: false,
        votos: false
    });
    const [isDrawerNoticiaOpen, setDrawerNoticiaOpen] = useState(false);    
    const [noticiaSelecionada, setNoticiaSelecionada] = useState(null);

    const [isDrawerVotacaoOpen, setDrawerVotacaoOpen] = useState(false);

    const [index, setIndex] = useState(0);
    const [questoes, setQuestoes] = useState([]);
    const [dadosVotacao, setDadosVotacao] = useState({});

    const [isAlertOpen, setAlertOpen] = useState(false);
    const cancelRef = React.useRef();

    const [votos, setVotos] = useState([]);
    const [votoSel, setVotoSel] = useState('');

    useEffect(() => {
        getNoticias();
        verificaPresenca();
    }, []);

    const getNoticias = async () => {
        const response = await api.get('noticias/listar_todas');
        setNoticias(response.data.noticias);
    };

    const verificaPresenca = async () => {
        const response = await api.get('/login_app/reuniao_atual?av='+appVersao);
        if(response.data.error === false){
            setDadosReuniao(response.data.data[0]);
        }
    };

    const selectVoto = (valor) => {
        setVotoSel(valor);
      };
    
    const setVoto = async () => {
        if(votoSel){
            votos.push({ [questoes[index].seq_conselho_reuniao_votacao]: votoSel });
            if (questoes.length > (index + 1)) {
                setIndex(index + 1);
                setVotoSel('');
            } else {
                await registrarVotos();
            }
        }else{
            toast({
                title: 'Atenção',
                description: "Selecione uma opção",
                status: 'info',
                duration: 3000,
                isClosable: false,
                position: 'top'
              });
        }
    };

    const verificaVotacao = async () => {
        setVotoSel('');
        setIndex(0);
        setVotos([]);
        setAguarde({...aguarde, votacao: true});
        const response = await api.get('/login_app/questao_votar?seq_conselho_reuniao='+dadosReuniao.seq_conselho_reuniao);
        if(response.data.error === false){
            var aux = [];
            for(var ii in response.data.data.questao){
                response.data.data.questao[ii].opcao = [];
            
                for(var i in response.data.data.opcao){
                    if(response.data.data.opcao[i].seq_conselho_reuniao_votacao === response.data.data.questao[ii].seq_conselho_reuniao_votacao){
                        response.data.data.questao[ii].opcao.push(response.data.data.opcao[i]);
                    }
                }
            }

            setQuestoes(response.data.data.questao);
            setDrawerVotacaoOpen(true);
        }else{
            setAlertMsg({title: 'Info', texto: response.data.msg});
            setAlertOpen(true);
        }
        setAguarde({...aguarde, votacao: false});
    };

    const registrarVotos = async () => {
        if(aguarde.votos == true){
            return;
        }
        setAguarde({...aguarde, votos: true});
        const response = await api.post('/login_app/registra_votos', {
          seq_conselho_reuniao: dadosReuniao.seq_conselho_reuniao,
          seq_conselho_reuniao_presenca: dadosReuniao.seq_conselho_reuniao_presenca,
          votos: JSON.stringify(votos)
        });
        if (response.data.error === false) {
          setAlertMsg({ title: 'Sucesso', texto: response.data.msg, callback: () => setDrawerVotacaoOpen(false) });
        } else {
          setAlertMsg({ title: 'Ops', texto: response.data.msg });
        }
        setAlertOpen(true);
        setAguarde({...aguarde, votos: false});
      };

    const registraVoto = async (voto) => {
        setAguarde({...aguarde, votos: true});
        console.log(dadosVotacao.questao.seq_conselho_reuniao_votacao);
        const response = await api.post('/login_app/questao_voto', {
            seq_conselho_reuniao: dadosReuniao.seq_conselho_reuniao,
            seq_conselho_reuniao_votacao: dadosVotacao.questao.seq_conselho_reuniao_votacao,
            seq_conselho_reuniao_presenca: dadosReuniao.seq_conselho_reuniao_presenca,
            voto: voto
        });

        if(response.data.error === false){
            setAlertMsg({title: 'Sucesso', texto: response.data.msg, callback: () => setDrawerVotacaoOpen(false)});
            setAlertOpen(true);
        }else{
            setAlertMsg({title: 'Ops', texto: response.data.msg, callback: () => setDrawerVotacaoOpen(false)});
            setAlertOpen(true);
        }
        setAguarde({...aguarde, votos: false});
    };

    const onAlertClose = () => {
        setAlertOpen(false);
        if(alertMsg.callback){
            alertMsg.callback();
        }
    };

    const DrawerNoticia = (props) => {
        if(props.noticia){
        return(<Drawer
            isOpen={props.isOpen}
            placement='right'
            onClose={props.onClose}
            size='lg'
        >
            <DrawerOverlay />
            <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>{props.noticia.titulo}</DrawerHeader>

            <DrawerBody>
                {props.noticia.imagem_boa ? <Image borderRadius='5px' mb='4' src={props.noticia.imagem_boa}/> : ''}
                <Box mb='4' dangerouslySetInnerHTML={{__html: props.noticia.corpo}}></Box>
            </DrawerBody>
            </DrawerContent>
        </Drawer>);}
        else
            return(<></>);
    };

    return(
        <>
        {dadosReuniao ?
        <Box backgroundImage={bg} color='white' p='6' mb='4' backgroundSize='cover'>
            <Flex direction='column' justifyContent='center' alignItems='center'>
                <Icon boxSize='8' as={IoPeopleOutline}/>
                <Text fontWeight='bold' lineHeight='1'>{dadosReuniao.titulo}</Text>
                <Text fontSize='sm' mb='4'>{dadosReuniao.hora}</Text>
                {dadosReuniao.presente === 't' ? 
                <Button colorScheme='whiteAlpha' mb='4' w='210px' onClick={()=>verificaPresenca()} color='black'><Icon boxSize='5' color='black' as={IoCheckmarkOutline} mr='1'/> Presença confirmada</Button> : 
                <Button colorScheme='blue' mb='4' w='210px' onClick={()=>verificaPresenca()}><Icon boxSize='5' as={IoReloadOutline} mr='1'/> Verificar presença</Button>}
                {dadosReuniao.em_andamento === 't' && dadosReuniao.presente === 't' ?
                <Button colorScheme='blue' w='210px' disabled={aguarde.votacao} onClick={() => verificaVotacao()}>
                    <Icon boxSize='5' as={IoChatboxOutline} mr='1'/> {aguarde.votacao ? 'Aguarde...' : 'Votação'}
                </Button> : 
                ''
                }
            </Flex>
        </Box> : ''}
        <Box px='4'>
            {noticias.map(n =>
                <Card mb='2' cursor='pointer' onClick={() => {setNoticiaSelecionada(n); setDrawerNoticiaOpen(true)}}>
                    <CardBody>
                        <Flex direction='row' justifyContent='center' alignItems='center'>
                            <Box pr='2'>
                                <Text fontSize='sm' color='#00adee'>{n.data_inicio}</Text>
                                <Text lineHeight='1.2'>{n.titulo}</Text>                                
                            </Box>
                            <Image borderRadius='5px' w='100px' src={n.imagem_boa}/>
                        </Flex>
                    </CardBody>
                </Card>
            )}
        </Box>
        <Box>
            <Text textAlign='center' color='gray.500'>Versão {appVersao}</Text>
        </Box>
        <AlertDialog
            isOpen={isAlertOpen}
            leastDestructiveRef={cancelRef}
            onClose={onAlertClose}
            closeOnEsc={false}
            closeOnOverlayClick={false}
        >
            <AlertDialogOverlay>
            <AlertDialogContent>
                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                    {alertMsg.title}
                </AlertDialogHeader>

                <AlertDialogBody>
                    {alertMsg.texto}
                </AlertDialogBody>

                <AlertDialogFooter>
                <Button colorScheme='blue' onClick={onAlertClose} ml={3}>
                    Ok
                </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
        <DrawerNoticia isOpen={isDrawerNoticiaOpen} onClose={() => setDrawerNoticiaOpen(false)} noticia={noticiaSelecionada}/>
        <Drawer
            isOpen={isDrawerVotacaoOpen}
            placement='right'
            onClose={() => setDrawerVotacaoOpen(false)}
            size='lg'
        >
            <DrawerOverlay />
            <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Votação</DrawerHeader>

            <DrawerBody>
            {questoes[index] && (
              <>
                <Text fontSize='sm' fontWeight='bold' mb='6'>Leia com atenção e após, clique nos botões para confirmar seu voto.</Text>
                <Text mb='6'>{questoes[index].tema}</Text>
                <Flex direction='column' justifyContent='center' alignItems='center'>
                  {questoes[index].opcao.map((opcao) => (
                    <Button
                      key={opcao.seq_conselho_reuniao_votacao_resposta}
                      boxShadow='md'
                      bg={opcao.seq_conselho_reuniao_votacao_resposta == votoSel ? 'blackAlpha.800' : 'white'}
                      _hover={opcao.seq_conselho_reuniao_votacao_resposta == votoSel ? 'blackAlpha.800' : 'white'}
                      textColor={opcao.seq_conselho_reuniao_votacao_resposta == votoSel ? 'white' : 'blackAlpha.800'}
                      mb='4'
                      w='100%'
                      onClick={() => selectVoto(opcao.seq_conselho_reuniao_votacao_resposta)}
                      disabled={aguarde.votos}
                    >
                      {opcao.resposta}
                    </Button>
                  ))}
                </Flex>
                <Button bgColor='blue.600' _hover={'blue.600'} textColor='white' w='100%' onClick={setVoto} disabled={aguarde.votos}>Confirmar</Button>
              </>
            )}
            </DrawerBody>
            </DrawerContent>
        </Drawer>
        </>
    );
};

export default Homemulti;